import { Routes } from '@angular/router';
import { AppLayout } from '../infrastructure/core/layouts/app-layout/app-layout';
import { AuthGuard } from '../infrastructure/shared/services/auth.guard';
import { rootRedirectGuard } from '../infrastructure/shared/services/root-redirect.guard';
import { LoginLayout } from '../infrastructure/core/layouts/login-layout/login-layout';
import { authRoutes } from '../infrastructure/auth/auth.routes';
import { appLayoutRoutes } from '../infrastructure/core/layouts/app-layout/app-layout.routes';

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', canActivate: [rootRedirectGuard], children: [] },
      ...appLayoutRoutes,
    ],
  },
  {
    path: '',
    component: LoginLayout,
    children: [
      {
        path: 'authentication',
        children: [...authRoutes],
      },
      { path: '**', redirectTo: 'authentication' },
    ],
  },

  // Fallback when no prior route is matched
  { path: '**', redirectTo: 'authentication' },
];
